<template>
<div>
  <Header/>
  <Navigationzj/>
  <div class="hxq_subpage">
    <div class="wrapper-panic">
      <div class="panic-today" id="panicTodayContent">
        <div class="panic-today-title">今日必买 爆款天天抢</div>
          <div class="panic-today-goods" id="panicTodayGoods">
            <div v-for="(item,index) in BuyTodayList" :key="index" class="panic-item">
              <div class="m-panic-goods ">
                <i class="rate"><p class="limit">还剩500件</p></i>
                <div class="pic">
                  <img :src="item.imgpath" style="display: inline-block;">
                  <div class="pic-time">距结束
                    <span>{{ day }}天 {{ hou }}时 {{ min }}分 {{ sec }}秒</span>
                  </div>
                </div>
                <div class="info">
                  <h3 class="title" :title="item.title">{{ item.title }}</h3>
                  <p class="msg" :title="item.sku">志鹏货号：{{ item.sku }}</p>
                  <p class="msg" :title="item.sales">产品销量：<count-to :start-val="0" :end-val="parseInt(item.sales)" :duration="2600" class="card-panel-num"/></p>
                  <p class="price">
                    <i></i><b>￥{{ item.sale_price }}</b>
                    <s>￥{{ item.tax_price }}</s>
                  </p>
                  <div class="bottom">
                    <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}" class="btn btn-red" target="_blank">立即抢购</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="g-wrapper" id="panicContent">
          <div class="m-panic-title">
            <div class="timedown-tip">
              <span class="title">限时抢购</span>
              <span class="type">距结束</span><span class="timedown" data-timedown="655993944">{{ day }}天 {{ hou }}时 {{ min }}分 {{ sec }}秒</span>
            </div>
          </div>
          <div class="m-panic-center">
            <div class="m-panic-filter header-fixed" id="m-panic-filter">
              <div class="_top g-clearfix">
                <span class="_left J_panicFilter">
                  <a title="推荐排序" href="javascript:;" :class="{active:flagd == 'g.order_num'}" @click="showflagd('g.order_num')">推荐排序</a>
                  <a title="价格" href="javascript:;" :class="{active:flagd == 'p.sale_price'}" @click="showflagd('p.sale_price')">价格</a>
                  <a title="销量" href="javascript:;" :class="{active:flagd == 'g.sales'}" @click="showflagd('g.sales')">销量</a>
                  <a title="折扣" href="javascript:;" :class="{active:flagd == 'p.tax_price'}" @click="showflagd('p.tax_price')">折扣</a>
                </span>
                <div class="_right J_panicFilterSel">
                  <!-- <div class="_right_item g-clearfix">
                    <a href="javascript:;" class="_item J_panicBrand" title="选择品牌" attr-type="brand">品牌</a>
                    <div class="_bottom J_paincFilterBtm">
                      <div class="panic-filter-brand  J_panicFilterBrand hide" attr-type="brand" style="display: none;">
                        <a class="active" href="javascript:;" title="全部品牌" attr-id="" attr-type="brand">全部品牌</a>
                        <a class="" href="javascript:;" title="世达" attr-id="1" attr-type="brand">世达</a>
                        <a class="" href="javascript:;" title="博世" attr-id="13" attr-type="brand">博世</a>
                        <a class="" href="javascript:;" title="东成" attr-id="19" attr-type="brand">东成</a>
                        <a class="" href="javascript:;" title="福禄克" attr-id="33" attr-type="brand">福禄克</a>
                        <a class="" href="javascript:;" title="优利德" attr-id="39" attr-type="brand">优利德</a>
                        <a class="" href="javascript:;" title="上工" attr-id="55" attr-type="brand">上工</a>
                        <a class="" href="javascript:;" title="亚德客" attr-id="91" attr-type="brand">亚德客</a>
                        <a class="" href="javascript:;" title="ABB" attr-id="95" attr-type="brand">ABB</a>
                        <a class="" href="javascript:;" title="西门子" attr-id="96" attr-type="brand">西门子</a>
                        <a class="" href="javascript:;" title="施耐德电气" attr-id="97" attr-type="brand">施耐德电气</a>
                        <a class="" href="javascript:;" title="欧姆龙" attr-id="103" attr-type="brand">欧姆龙</a>
                        <a class="" href="javascript:;" title="德力西电气" attr-id="104" attr-type="brand">德力西电气</a>
                        <a class="" href="javascript:;" title="正泰" attr-id="105" attr-type="brand">正泰</a>
                        <a class="" href="javascript:;" title="3M" attr-id="127" attr-type="brand">3M</a>
                        <a class="" href="javascript:;" title="安思尔" attr-id="130" attr-type="brand">安思尔</a>
                        <a class="" href="javascript:;" title="代尔塔" attr-id="132" attr-type="brand">代尔塔</a>
                        <a class="" href="javascript:;" title="诺力（NOBLELIFT）" attr-id="181" attr-type="brand">诺力（NOBLELIFT）</a>
                        <a class="" href="javascript:;" title="得力（DELI）" attr-id="276" attr-type="brand">得力（DELI）</a>
                        <a class="" href="javascript:;" title="赛立特" attr-id="415" attr-type="brand">赛立特</a>
                        <a class="" href="javascript:;" title="工盾坊" attr-id="482" attr-type="brand">工盾坊</a>
                        <a class="" href="javascript:;" title="上量" attr-id="486" attr-type="brand">上量</a>
                        <a class="" href="javascript:;" title="威码" attr-id="617" attr-type="brand">威码</a>
                        <a class="" href="javascript:;" title="腾盛" attr-id="873" attr-type="brand">腾盛</a>
                        <a class="" href="javascript:;" title="麦迪康" attr-id="1054" attr-type="brand">麦迪康</a>
                        <a class="" href="javascript:;" title="友友" attr-id="2385" attr-type="brand">友友</a>
                        <a class="" href="javascript:;" title="迪团" attr-id="9323" attr-type="brand">迪团</a>
                        <a class="" href="javascript:;" title="普源RIGOL" attr-id="12368" attr-type="brand">普源RIGOL</a>
                        <a class="" href="javascript:;" title="禾素时代" attr-id="12483" attr-type="brand">禾素时代</a>
                        <a class="" href="javascript:;" title="金维尔" attr-id="12778" attr-type="brand">金维尔</a>
                        <a class="" href="javascript:;" title="恒雅" attr-id="13681" attr-type="brand">恒雅</a>
                      </div>
                    </div>
                  </div>
                  <div class="_right_item g-clearfix">
                    <a href="javascript:;" class="_item J_panicCate" title="选择分类" attr-type="cate">分类</a>
                    <div class="_bottom J_paincFilterBtm">
                      <div class="panic-filter-cate J_panicFilterCate hide" attr-type="cate" style="display: none;">
                        <a class="active" href="javascript:;" title="全部分类" attr-cateno="" attr-type="cate">全部分类</a>
                        <a class="" href="javascript:;" title="内六角扳手" attr-cateno="101212" attr-type="cate">内六角扳手</a>
                        <a class="" href="javascript:;" title="套筒组套" attr-cateno="101223" attr-type="cate">套筒组套</a>
                        <a class="" href="javascript:;" title="螺丝批组套" attr-cateno="101314" attr-type="cate">螺丝批组套</a>
                        <a class="" href="javascript:;" title="电钻/冲击钻" attr-cateno="101910" attr-type="cate">电钻/冲击钻</a>
                        <a class="" href="javascript:;" title="冲击起子机" attr-cateno="101912" attr-type="cate">冲击起子机</a>
                        <a class="" href="javascript:;" title="角磨机/直磨机" attr-cateno="101916" attr-type="cate">角磨机/直磨机</a>
                        <a class="" href="javascript:;" title="卡尺" attr-cateno="201015" attr-type="cate">卡尺</a>
                        <a class="" href="javascript:;" title="普通高速钢麻花钻" attr-cateno="201710" attr-type="cate">普通高速钢麻花钻</a>
                        <a class="" href="javascript:;" title="数字万用表" attr-cateno="202610" attr-type="cate">数字万用表</a>
                        <a class="" href="javascript:;" title="台式示波器" attr-cateno="202710" attr-type="cate">台式示波器</a>
                        <a class="" href="javascript:;" title="封箱胶带" attr-cateno="302215" attr-type="cate">封箱胶带</a>
                        <a class="" href="javascript:;" title="其他胶带" attr-cateno="302220" attr-type="cate">其他胶带</a>
                        <a class="" href="javascript:;" title="电磁阀" attr-cateno="402811" attr-type="cate">电磁阀</a>
                        <a class="" href="javascript:;" title="微型断路器" attr-cateno="501110" attr-type="cate">微型断路器</a>
                        <a class="" href="javascript:;" title="中间继电器" attr-cateno="501111" attr-type="cate">中间继电器</a>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="m-panic-list m-painc-list-ing g-clearfix J_panicSnatchGoods" v-loading="loading">
            <div v-for="(item,index) in FlashSaleList" :key="index" class="panic-item">
              <div class="m-panic-goods ">
                <i class="rate"><p class="limit">还剩500件</p></i>
                <div class="pic">
                    <img :src="item.imgpath" style="display: inline-block;">
                </div>
                <div class="info">
                  <h3 class="title" :title="item.title">{{ item.title }}</h3>
                  <p class="msg" :title="item.sku">志鹏货号：{{ item.sku }}</p>
                  <p class="msg" :title="item.sales">产品销量：<count-to :start-val="0" :end-val="parseInt(item.sales)" :duration="2600" class="card-panel-num"/></p>
                  <p class="price">
                    <i></i><b>￥{{ item.sale_price }}</b>
                    <s>￥{{ item.tax_price }}</s>
                  </p>
                  <div class="bottom">
                    <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}" class="btn btn-red" target="_blank">立即抢购</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import api from '@/api/flashsale'
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import CountTo from 'vue-count-to'

export default {
  name: 'Flashsale',
  components: {
    Header,
    Navigationzj,
    Footer,
    CountTo
  },
  data () {
    return {
      BuyTodayList: [],
      FlashSaleList: [],
      day: 0,
      hou: 0,
      min: 0,
      sec: 0,
      ssec: 0,
      endTime: '',
      flagd: 'g.order_num',
      loading: false
    }
  },
  created () {
    this.getBuyToday()
    this.getFlashSale()
    this.getEndtime()
    this.time()
  },
  mounted () {
  },
  methods: {
    getBuyToday () {
      api.getBuyToday().then(res => {
        this.BuyTodayList = res.items
      })
    },
    getFlashSale () {
      this.loading = true
      this.FlashSaleList = []
      api.getFlashSale({ 'order': this.flagd }).then(res => {
        this.FlashSaleList = res.items
        this.loading = false
      })
    },
    getEndtime () {
      api.getEndTime({ 'id': 1 }).then(res => {
        this.endTime = res.items.endtime
      })
    },
    showflagd (sign) {
      this.flagd = sign
      this.getFlashSale()
    },
    time () {
      var that = this
      setInterval(function timestampToTime () {
        var date = (new Date(that.endTime)) - (new Date())
        // new Date当前的时间戳，也可以换成自定义的时间戳
        if (date > 0) {
          let time = date / 1000
          // 获取时、分、秒,毫秒
          that.day = parseInt(time / (24 * 3600)) < 10 ? ('0' + parseInt(time / (24 * 3600))) : parseInt(time / (24 * 3600))
          that.hou = parseInt((time % (60 * 60 * 24)) / 3600) < 10 ? ('0' + parseInt((time % (60 * 60 * 24)) / 3600)) : parseInt((time % (60 * 60 * 24)) / 3600)
          that.min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) / 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) / 60)
          that.sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) % 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) % 60)
          that.ssec = parseInt(((date % (60 * 60 * 24)) % 3600) / 60) % 10
        } else {
          // 活动已结束，全部设置为'00'
          that.day = '00'
          that.hou = '00'
          that.min = '00'
          that.sec = '00'
        }
      }, 100)
    }
  }
}
</script>
<style scoped>
.wrapper-panic {
  width: 100%;
  background: url(../../assets/images/banner-bg.png) no-repeat top;
  background-size: contain;
  padding-top: 840px;
}
.panic-today {
  width: 1220px;
  padding-left: 15px;
  box-sizing: border-box;
  height: 568px;
  margin: 0 auto;
  background: linear-gradient(270deg,#ff4e15,#f20000);
  border-radius: 16px;
}
.panic-today .panic-today-title {
  font-size: 28px;
  color: #fff;
  padding: 30px 0 35px;
  text-align: center;
  line-height: 30px;
}
.panic-today .panic-today-goods {
  width: 1208px;
}
.panic-item {
  float: left;
  width: 284px;
  height: 458px;
  border-radius: 8px;
  background: #fff;
  margin-right: 18px;
}
.panic-item .m-panic-goods {
  display: block;
  position: relative;
}
.panic-item .m-panic-goods .rate {
  position: absolute;
  right: 17px;
  top: 20px;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  border: 1px solid #ed2920;
  border-radius: 4px;
  background: #fef0f0;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  color: #ed2920;
  z-index: 1;
}
.panic-item .m-panic-goods .pic {
  position: relative;
  height: 240px;
}
.panic-item .m-panic-goods .pic img {
  width: 220px;
  height: 220px;
  vertical-align: center;
  margin-left: 32px;
  margin-top: 20px;
}
.panic-item .m-panic-goods .pic .pic-time {
  width: 264px;
  background: rgba(0,0,0,.65);
  left: 10px;
}
.panic-item .m-panic-goods .pic .pic-time, .panic-item .m-panic-goods .pic .tip {
  position: absolute;
  bottom: 0;
  height: 34px;
  line-height: 34px;
  text-align: center;
  color: #fff;
}
.panic-item .m-panic-goods .info {
  position: relative;
  height: 198px;
  overflow: hidden;
  color: #888;
  font-size: 14px;
  padding: 20px 17px 0;
}
.panic-item .m-panic-goods .info .title {
  height: 46px;
  line-height: 21px;
  overflow: hidden;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #222;
}
.panic-item .m-panic-goods .info .msg {
  color: #888;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  height: 18px;
}
.panic-item .m-panic-goods .info .price {
    margin-top: 13px;
    margin-bottom: 5px;
    line-height: 20px;
}
.panic-item .m-panic-goods .info .price b {
  font-size: 20px;
  font-weight: 400;
  color: #ed2920;
  line-height: 20px;
}
.panic-item .m-panic-goods .info .price s {
  margin-left: 10px;
  font-size: 12px;
}
.panic-item .m-panic-goods .info .bottom {
  position: absolute;
  bottom: 20px;
  left: 17px;
}
.panic-item .m-panic-goods .info .bottom .btn.btn-red {
  color: #fff;
  background: #ed2920;
}
.panic-item .m-panic-goods .info .bottom .btn {
  display: inline-block;
  width: 244px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  text-align: center;
  vertical-align: top;
  font-size: 14px;
  color: #ed2920;
}
.g-wrapper {
  width: 1190px;
}
.g-wrapper, .g-wrapper-new {
  margin-left: auto;
  margin-right: auto;
}
.m-panic-title {
  height: 100px;
  margin-top: 20px;
  background: #fff;
}
.m-panic-title .timedown-tip {
  overflow: hidden;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.m-panic-title .timedown-tip .title {
  display: inline-block;
  padding-left: 56px;
  /* background: url(/static/image/panicbuy/ic_snooze@2x.1.png) no-repeat 0; */
  background-size: 36px;
  font-size: 28px;
  vertical-align: top;
}
.m-panic-title .timedown-tip .type {
  margin-left: 30px;
  font-size: 14px;
}
.m-panic-title .timedown-tip .timedown {
  margin-left: 10px;
  font-size: 28px;
  color: #222;
}
.m-panic-center {
  height: 45px;
  margin-bottom: 20px;
}
.m-panic-filter {
  position: relative;
  width: 1190px;
}
.m-panic-filter ._top {
  line-height: 40px;
  color: #222;
  font-size: 12px;
  border-top: 1px solid rgba(0,0,0,.08);
  background: #fff;
}
.m-panic-filter ._top span._left {
  float: left;
  border-bottom: 1px solid rgba(0,0,0,.08);
}
.m-panic-filter ._top span._left a {
  float: left;
  border-right: 1px solid rgba(0,0,0,.08);
  padding: 0 20px;
  line-height: 40px;
  cursor: pointer;
  color: #222;
  text-decoration: none;
  transition: .2s;
}
.m-panic-filter ._top span._left a.active {
  background-color: #ed2920;
  color: #fff;
}
.m-panic-filter ._top span._left a.price {
  padding: 0 20px;
}
.m-panic-filter ._top div._right {
  float: right;
}
.m-panic-filter ._top div._right div._right_item {
  float: left;
}
.m-panic-filter ._top div._right a._item {
  float: right;
  line-height: 38px;
  position: relative;
  height: 40px;
  padding: 0 20px;
  cursor: pointer;
  box-sizing: border-box;
  color: rgba(0,0,0,.85);
  border: 1px solid;
  border-color: #fff transparent;
}
.m-panic-filter ._top div._right a._item:after {
  content: "";
  display: inline-block;
  width: 10px;
  height: 6px;
  margin-left: 4px;
  background: url(../../assets/images/jaintou_01.png) no-repeat 50%;
  vertical-align: middle;
  background-size: 10px 6px;
}
.m-panic-filter ._top div._right ._bottom {
  position: absolute;
  top: 39px;
  right: 0;
  z-index: 100;
  width: 1190px;
}
.m-panic-filter ._top div._right ._bottom .panic-filter-brand, .m-panic-filter ._top div._right ._bottom .panic-filter-cate {
  float: right;
  background: #fff;
  line-height: 0;
  padding: 5px 5px 15px 25px;
  border-radius: 2px;
  border: 1px solid #ed2920;
}
.m-panic-filter ._top div._right ._bottom .panic-filter-brand a.active, .m-panic-filter ._top div._right ._bottom .panic-filter-cate a.active {
  background: #ed2920;
  border-radius: 2px;
  color: #fff;
}
.m-panic-filter ._top div._right ._bottom .panic-filter-brand a, .m-panic-filter ._top div._right ._bottom .panic-filter-cate a {
  display: inline-block;
  padding: 5px;
  color: #222;
  font-size: 12px;
  margin-top: 10px;
  margin-right: 20px;
  cursor: pointer;
  line-height: 12px;
  white-space: nowrap;
}
.m-panic-list {
  width: 1208px;
}
.m-panic-list .panic-item {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/flashsale/index.vue